import styled, { css } from 'styled-components'
import { OUTLINE_COLOR, GREY_BACKGROUND, FONT_BASE_COLOR } from '@CSSVars/colors'


export const withBorderCss = css`
  tr {
    td, th{
      border-left: 1px solid ${OUTLINE_COLOR};
      border-right: 1px solid ${OUTLINE_COLOR};
      &:first-child {
        border-left: 0;
      }
      &:last-child {
        border-right: 0;
      }
    }
  }
`
export const _Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  thead {
    background: white;
  }
  ${({ withBorder }) => (withBorder && withBorderCss)}
`

export const _TableHead = styled.th`
  padding: 20px;
  text-align: center;
  backface-visibility: hidden;
  position: relative;
  color: ${FONT_BASE_COLOR};
  background: white !important;
`
export const tableCellCss = css`
  padding: 20px;
  text-align: center;
  backface-visibility: hidden;
`
export const _TableCell = styled.td`
  ${tableCellCss}
`
export const _TableBody = styled.tbody`
  tr {
      &:nth-child(odd) {
        background: ${GREY_BACKGROUND};
    }
  }
`

export const _SliderRow = styled.tr`

`
export const _SliderTable = styled(_Table)`
  ${_TableHead} {
    padding: 20px;
    text-align: center;
    color: ${FONT_BASE_COLOR};
    height: 76px;
  }
  ${_TableCell} {
    padding: 20px;
    text-align: center;
    height: 76px;
  }

  ${_SliderRow}:nth-child(odd) {
    background: ${GREY_BACKGROUND} !important;
  }

  @media screen and (max-width: 414px) {
    ${_TableHead} {
      padding: 20px 10px;
      text-align: center;
      color: ${FONT_BASE_COLOR};
      height: 76px;
    }
    ${_TableCell} {
      padding: 20px 10px;
      text-align: center;
      height: 76px;
    }

  }
`
